import { render, staticRenderFns } from "./SafetyManagerManageDetail.vue?vue&type=template&id=35442bce&"
import script from "./SafetyManagerManageDetail.vue?vue&type=script&lang=js&"
export * from "./SafetyManagerManageDetail.vue?vue&type=script&lang=js&"
import style0 from "./SafetyManagerManageDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports